<template>
  <div class="dialog_container">
    <el-dialog
      title="修改车辆机损事故信息"
      :visible="dialogShow"
      width="436px"
      @close="dialogClose"
      top="15vh"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="dialog_box">
        <el-form
          ref="redactForm"
          class="add_staff_form"
          :model="redactForm"
          label-width="130px"
          :rules="reactRules"
        >
          <el-form-item label="事故编号：" prop="accidentSn">
            <el-input
              placeholder="请输入事故编号"
              v-model="redactForm.accidentSn"
            ></el-input>
          </el-form-item>
          <el-form-item label="事故时间：" prop="accidentTimeStr">
            <el-date-picker
              v-model="redactForm.accidentTimeStr"
              type="date"
              placeholder="请选择事故时间"
              :clearable="false"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="事故地点：" prop="accidentAddress">
            <el-input
              placeholder="请输入事故地点"
              v-model="redactForm.accidentAddress"
            ></el-input>
          </el-form-item>
          <el-form-item label="事故性质：" prop="accidentType">
            <el-select
              v-model="redactForm.accidentType"
              placeholder="请选择事故性质"
            >
              <el-option
                v-for="item in accidentTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="事故责任：" prop="accidentDuty">
            <el-select
              v-model="redactForm.accidentDuty"
              placeholder="请选择事故责任"
            >
              <el-option
                v-for="item in accidentDutyList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车辆损坏情况：" prop="carSituation">
            <el-input
              placeholder="请输入车辆损坏情况"
              v-model="redactForm.carSituation"
            ></el-input>
          </el-form-item>
          <el-form-item label="登记人员：">
            <el-input v-model="username" disabled></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="dialogClose">取 消</el-button>
        <el-button class="btn btn_ok" @click="confirm('redactForm')"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { dateTransition } from "@/utils/util.js";
export default {
  name: "",
  data() {
    return {
      redactForm: {},
      username: "",
      accidentTypeList: [],
      accidentDutyList: [],
      reactRules: {
        accidentSn: [
          { required: true, message: "请输入事故编号", trigger: "blur" },
        ],
        accidentTimeStr: [
          { required: true, message: "请选择事故时间", trigger: "change" },
        ],
        accidentAddress: [
          { required: true, message: "请输入事故地点", trigger: "blur" },
        ],
        accidentType: [
          { required: true, message: "请选择事故性质", trigger: "change" },
        ],
        accidentDuty: [
          { required: true, message: "请选择事故责任", trigger: "change" },
        ],
        carSituation: [
          { required: true, message: "请输入车辆损坏情况", trigger: "blur" },
        ],
      },
    };
  },
  components: {},
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    dialogData: Object,
    carId:Number
  },
  watch: {
    dialogShow(val) {
      if (val) {
        const data = JSON.parse(sessionStorage.getItem("userInfo"));
        this.username = data.username;
        this.redactForm = {
          id: this.dialogData.id,
          accidentSn: this.dialogData.accidentSn,
          accidentTimeStr: new Date(this.dialogData.accidentTime),
          accidentAddress: this.dialogData.accidentAddress,
          accidentDuty: this.dialogData.accidentDutyStr,
          carSituation: this.dialogData.carSituation,
          accidentType: this.dialogData.accidentTypeStr,
          carId:this.carId
        };
        this.getAccidentSelect();
      }
    },
  },
  created() {},
  methods: {
    confirm(formName) {
      console.log(this.redactForm);
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        this.redactForm.accidentTimeStr = dateTransition(
          this.redactForm.accidentTimeStr
        );
        if (typeof this.redactForm.accidentDuty == "string") {
          this.accidentDutyList.forEach((i) => {
            if (i.name == this.redactForm.accidentDuty) {
              this.redactForm.accidentDuty = i.id;
            }
          });
        }
        if (typeof this.redactForm.accidentType == "string") {
          this.accidentTypeList.forEach((i) => {
            if (i.name == this.redactForm.accidentType) {
              this.redactForm.accidentType = i.id;
            }
          });
        }
        this.$http.updateAccident(this.redactForm).then((res) => {
          if (res.code === 0) {
            this.$message.success(res.msg);
            this.$parent.getList();
            this.redactForm = {};
            this.$emit("update:dialogShow", false);
          } else {
            this.$message.info(res.msg);
          }
        });
      });
    },
    getAccidentSelect() {
      this.$http.getCarAccidentSelect(1).then((res) => {
        if (res.code == 0) {
          this.accidentTypeList = res.data;
        } else {
          this.accidentTypeList = [];
        }
      });
      this.$http.getCarAccidentSelect(2).then((res) => {
        if (res.code == 0) {
          this.accidentDutyList = res.data;
        } else {
          this.accidentDutyList = [];
        }
      });
    },
    dialogClose() {
      this.$emit("update:dialogShow", false);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../redact";
/deep/.el-input__inner {
  width: 250px;
}
.hint_box {
  width: 100%;
  display: flex;
  .hint_placeholder {
    width: 100px;
  }
  .hint_text {
    width: 250px;
    font-size: 11px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #9b9b9b;
  }
}
.limit {
  /deep/.el-form-item__content {
    display: flex;
  }
  /deep/.el-input__inner {
    width: 220px;
  }
}
.yuan_shangchuan {
  position: absolute;
  top: 0;
  right: 20px;
}
.baodan_img {
  /deep/.el-input__inner {
    width: 206px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/carTechnology_component/tabDialog/reactCarAccident.vue